"use client";

import { useEffect } from "react";
import { Cta } from "@/components/marketing/Cta";
import { CtaLink } from "@/components/marketing/CtaLink";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    if (typeof window !== "undefined") {
      console.error("[apex-digital]", error);
    }
  }, [error]);

  return (
    <section className="relative z-10 mx-auto max-w-[60ch] px-5 py-24 md:px-10 md:py-40 lg:px-16">
      <div
        className="font-mono text-[11px] uppercase"
        style={{
          color: "var(--color-accent)",
          letterSpacing: "0.12em",
        }}
      >
        ↳ Something broke
      </div>
      <h1
        className="mt-8"
        style={{
          fontFamily: "var(--font-display)",
          fontSize: "clamp(48px, 7vw, 108px)",
          fontWeight: 400,
          lineHeight: 0.92,
          letterSpacing: "-0.045em",
        }}
      >
        Something broke on our end.
      </h1>
      <p className="mt-8 text-[17px] leading-[1.55] text-[color:var(--color-fg-muted)]">
        Refresh once. If it still breaks, email{" "}
        <a href="mailto:info@apexflowlabs.com">
          info@apexflowlabs.com
        </a>{" "}
        with what you were doing. We'll fix it and send you a $7 wall art for the trouble.
      </p>
      <div className="mt-10 flex flex-wrap gap-3">
        <Cta type="button" variant="primary" onClick={reset}>
          Refresh
        </Cta>
      </div>
    </section>
  );
}
